import axios from 'axios';

import type { UserProgress } from '../interfaces';
import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class UserProgressDao {
  static async getUserProgress(env: Environment, personId: number) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.get<UserProgress>(`${url}/v2/progresses`, {
      params: { personId },
    });
    return data;
  }
}
